import { TelemetryErrorEvent } from '../../utilities/insights/models/telemetry-error-event';

export class GeneralError extends TelemetryErrorEvent {
	constructor(params: GeneralErrorParams) {
		super({ internalError: params?.internalError });
		this.context.message = params?.message || 'An unexpected error has occurred.';
	}
}

interface GeneralErrorParams {
	internalError: Error;
	message: string;
}
